export enum TVGStatus {
    DRAFT = 'DRAFT',
    CONCEPT = 'CONCEPT',
    VALID = 'VALID',
    INVALID = 'INVALID',
    RUNOUT = 'RUNOUT'
}

const TVG_STATUS_PREFIX = 'ENUM.TVG_STATUS.';

export function tvgStatusTranslationKey(status: TVGStatus | string | undefined): string {
    return TVG_STATUS_PREFIX + status;
}

export const tvgStatusTranslationKeys = Object.values(TVGStatus).reduce((translationKeys, status) => {
    translationKeys[status] = tvgStatusTranslationKey(status);
    return translationKeys;
}, {} as Record<TVGStatus, string>);
